import {
  FaFacebook,
  FaYoutube,
  FaInstagramSquare,
  FaWhatsappSquare,
} from "react-icons/fa";

export default function Footer() {
  return (
    <>
      <div className="max-container-width d-flex flex-column flex-lg-row justify-content-between py-5">
        <div>
          <h6 className="primary-text-blue">
            2023 امت پرودکشن، حقوق نشر مطالب این سایت برای همگان مجاز می باشد.
          </h6>
        </div>
        <div className="vr vr-blurry hidden d-sm-none d-lg-block"></div>
        <div>
          <h4 className="mb-3 dark-text-blue">
            <strong>صفحات اجتماعی</strong>
          </h4>
          <div className="d-flex gap-3">
            <a
              href="https://www.youtube.com/@ummatproduction7091"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-circle p-2 text-body btn btn-default btn-circle shadow-sm icon-links border"
            >
              <FaYoutube style={{ height: "25px", width: "25px" }} />
            </a>
            <a
              href="https://www.facebook.com/people/Ummat-Production-%D8%A7%D9%85%D8%AA-%D9%BE%D8%B1%D9%88%D8%AF%DA%A9%D8%B4%D9%86/61579394770099/?rdid=CwgcDRyrGSO60ivv&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1FeAvWiwgi%2F"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-circle p-2 text-body btn btn-default btn-circle shadow-sm icon-links border"
            >
              <FaFacebook style={{ height: "25px", width: "25px" }} />
            </a>
            <a
              href="http://bitly.cx/gCiQ"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-circle p-2 text-body btn btn-default btn-circle shadow-sm icon-links border"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="25"
                fill="currentColor"
                className="bi bi-twitter-x"
                viewBox="0 0 16 16"
              >
                <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865l8.875 11.633Z" />
              </svg>
            </a>
            <a
              href="https://t.me/UmmatNews21"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-circle p-2 text-body btn btn-default btn-circle shadow-sm icon-links border"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="25"
                fill="currentColor"
                className="bi bi-telegram"
                viewBox="0 0 16 16"
              >
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z" />
              </svg>
            </a>
            <a
              href="http://bitly.cx/sQ0rA"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-circle p-2 text-body btn btn-default btn-circle shadow-sm icon-links border"
            >
              <FaInstagramSquare style={{ height: "25px", width: "25px" }} />
            </a>
            <a
              href="http://bitly.cx/llRoY"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-circle p-2 text-body btn btn-default btn-circle shadow-sm icon-links border"
            >
              <svg
                stroke="currentColor"
                fill="currentColor"
                stroke-width="0"
                viewBox="0 0 1024 1024"
                fill-rule="evenodd"
                height="25"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M800 112.962C800 50.575 749.425 0 687.038 0H112.962C50.575 0 0 50.575 0 112.962v574.076C0 749.426 50.575 800 112.962 800h574.076C749.425 800 800 749.426 800 687.038zM662.759 348.916c-51.615.577-99.71-15.027-141.938-43.927v202.874c0 90.166-61.72 167.62-148.996 187.848-119.068 27.165-219.864-58.954-232.577-161.835-13.294-102.884 52.322-193.051 152.892-213.281 19.651-4.045 49.209-4.045 64.458-.577v108.661c-4.692-1.153-9.086-2.31-13.709-2.888-39.304-6.937-77.371 12.715-92.977 48.55-15.605 35.838-5.16 77.451 26.629 101.73 26.586 20.806 56.085 23.694 86.14 9.822 30.057-13.291 46.21-37.567 49.676-70.512.578-4.622.546-9.826.546-15.028V110.206c0-10.981.086-10.502 11.068-10.502h86.12c6.36 0 8.673.915 9.25 8.433 4.621 67.047 55.526 124.147 120.838 132.818 6.937 1.155 14.369 1.613 22.58 2.19z"
                  transform="translate(112 112)"
                ></path>
              </svg>
            </a>
            <a
              href="https://www.whatsapp.com/channel/0029VbB1fCB1NCrTJ0IusM0s"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-circle p-2 text-body btn btn-default btn-circle shadow-sm icon-links border"
            >
              <FaWhatsappSquare style={{ height: "25px", width: "25px" }} />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
